/**
 * Code below is a temp fix until the issue is resolved in master bracnh of Boostrap 4.
 * Link to issue: https://github.com/twbs/bootstrap/issues/20261
 */

// save the original function object
var _super = $.fn.scrollspy;
var DATA_KEY = 'bs.scrollspy';
var EVENT_KEY = '.' + DATA_KEY;
var DATA_API_KEY = '.data-api';

var Event = {
    ACTIVATE: 'activate' + EVENT_KEY,
    SCROLL: 'scroll' + EVENT_KEY,
    LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY
};

var Selector = {
    DATA_SPY: '[data-spy="scroll"]',
    ACTIVE: '.active',
    LIST_ITEM: '.list-item',
    LI: 'li',
    LI_DROPDOWN: 'li.dropdown',
    NAV_LINKS: '.nav-link',
    DROPDOWN: '.dropdown',
    DROPDOWN_ITEMS: '.dropdown-item',
    DROPDOWN_TOGGLE: '.dropdown-toggle'
};

// create a new constructor
var ScrollSpy2 = function(element, config) {

    this._element = element;
    this._scrollElement = element.tagName === 'BODY' ? window : element;
    this._config = this._getConfig(config);
    this._selector = this._config.target + ' ' + Selector.NAV_LINKS + ',' + (this._config.target + ' ' + Selector.DROPDOWN_ITEMS);
    this._offsets = [];
    this._targets = [];
    this._activeTarget = null;
    this._scrollHeight = 0;

    this._getScrollTop = function() {
        return this._scrollElement === window ?
            this._scrollElement.scrollY || $(this._scrollElement).scrollTop() : this._scrollElement.scrollTop;
    };

    $(this._scrollElement).on(Event.SCROLL, $.proxy(this._process, this));

    this.refresh();
    this._process();

};

// extend prototypes and add a super function
ScrollSpy2.prototype = _super.Constructor.prototype;

// override the old initialization with the new constructor
$.fn.scrollspy = $.extend(function(config) {

    return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = config = $.extend({}, _super.defaults, data, typeof config == 'object' && config);
        if (!data) {
            data = new ScrollSpy2(this, _config);
            $(this).data(DATA_KEY, data);
        }
        if (typeof config === 'string') {
            if (data[config] === undefined) {
                throw new Error('No method named "' + config + '"');
            }
            data[config]();
        }
    });

}, $.fn.scrollspy);



//////////////////
// WEBPACK FOOTER
// ./~/jslib-edm-bootstrap/src/scrollspy/scrollspy.js
// module id = 399
// module chunks = 18